import React from "react";
import ReactMarkdown from "react-markdown";
import { Box } from "@mui/material";

const markdownSx = (compact = false) => ({
  color: "text.primary",
  fontFamily: '"Inter", "Aptos", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: compact ? "0.98rem" : "1rem",
  lineHeight: compact ? 1.5 : 1.62,
  letterSpacing: 0,
  overflowWrap: "anywhere",
  "& > :first-of-type": {
    mt: 0,
  },
  "& > :last-child": {
    mb: 0,
  },
  "& p": {
    my: compact ? 0.7 : 0.85,
    fontWeight: 430,
  },
  "& h1, & h2, & h3, & h4": {
    mt: compact ? 1.25 : 1.5,
    mb: 0.75,
    fontWeight: 900,
    lineHeight: 1.2,
    letterSpacing: 0,
    color: "text.primary",
  },
  "& h1": {
    fontSize: compact ? "1.22rem" : "1.45rem",
  },
  "& h2": {
    fontSize: compact ? "1.12rem" : "1.28rem",
  },
  "& h3": {
    fontSize: compact ? "1.04rem" : "1.14rem",
  },
  "& h4": {
    fontSize: "1rem",
  },
  "& ul, & ol": {
    my: compact ? 0.7 : 0.85,
    pl: compact ? 2.35 : 2.6,
  },
  "& li": {
    my: 0.35,
    pl: 0.1,
    fontWeight: 430,
  },
  "& strong": {
    fontWeight: 900,
  },
  "& blockquote": {
    my: 1,
    mx: 0,
    pl: 1.35,
    borderLeft: "3px solid rgba(184,115,51,0.34)",
    color: "text.secondary",
  },
  "& code": {
    px: 0.45,
    py: 0.15,
    borderRadius: 1,
    bgcolor: "rgba(184,115,51,0.10)",
    color: "#7D4A22",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: "0.92em",
  },
  "& pre": {
    my: 1,
    p: 1.25,
    borderRadius: 2,
    bgcolor: "rgba(20,18,15,0.045)",
    overflowX: "auto",
  },
  "& pre code": {
    p: 0,
    bgcolor: "transparent",
    color: "inherit",
  },
  "& a": {
    color: "#9A5A24",
    fontWeight: 800,
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
});

export default function CasperMarkdown({ children, compact = false }) {
  const content = String(children || "");
  if (!content.trim()) return null;

  return (
    <Box sx={markdownSx(compact)}>
      <ReactMarkdown
        components={{
          a: ({ href, children: linkChildren, ...props }) => (
            <a href={href} target="_blank" rel="noreferrer" {...props}>
              {linkChildren}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
}
